module.exports = __webpack_public_path__ + "images/warning-icon.c2d07dee54bfb84ba8c1a1bae8d8aeb5.png";